import Marquee from "react-fast-marquee";

export default function TopMarquee() {
  return (
    <div className="bg-black text-[#D4FF00] border-b-2 border-black py-2" data-testid="top-marquee">
      <Marquee gradient={false} speed={60}>
        <span className="font-display text-lg tracking-wider mx-6">OUTLAW-D // CUSTOM STREETWEAR // THRIFT DROPS // MADE IN INDIA // </span>
        <span className="font-display text-lg tracking-wider mx-6 text-[#FF007F]">VERIFIED SELLERS // BUYER PROTECTION // </span>
        <span className="font-display text-lg tracking-wider mx-6">1 OF 1 PIECES // HAND-PAINTED // </span>
        <span className="font-display text-lg tracking-wider mx-6 text-[#FF007F]">NEW DROPS EVERY FRIDAY // </span>
      </Marquee>
    </div>
  );
}
